import { getUsers, addUser, editUser, deleteUser,changeStatus } from "./users.action";

export { usersReducer } from "./users.reducer";
export { watchUsers } from "./users.saga";

export const usersActions = {
  /** Users */
  getUsers,
  addUser,
  editUser,
  deleteUser,
  changeStatus
};
